module.exports = __webpack_public_path__ + "img/intro_mock.56c25b75.png";